/**
 * Normaliza uma leitura de hodômetro para inteiro.
 *
 * O painel do veículo marca décimos (11306.7) e é assim que o usuário digita.
 * Já `expense_items.km_start`, `km_end` e `additional_km` são colunas `integer`
 * no Postgres: um decimal chegando lá derruba o INSERT com
 * `invalid input syntax for type integer` (22P02), que a API devolve como
 * "Internal server error".
 *
 * Arredondar preserva a distância percorrida — que é o valor que gera o
 * ressarcimento — porque os dois extremos sofrem o mesmo tratamento.
 *
 * Valor vazio ou não numérico vira 0, mantendo o comportamento anterior de
 * `Number(campo)` nos cálculos da tela.
 */
export function roundKm(value?: string | number | null): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.round(parsed) : 0;
}

export default roundKm;
